import { useQuery } from '@tanstack/react-query'
import { getSupportCategories } from '../api/support.api'
import { panelsQueryKeys } from '../api/queryKeys'

/** The answers to the support panel's first question, in order. */
export function useSupportCategories() {
  const query = useQuery({
    queryKey: panelsQueryKeys.supportCategories,
    queryFn: getSupportCategories,
    // Staff rarely change them; a session doesn't need to refetch.
    staleTime: Infinity,
  })

  return {
    categories: query.data?.categories ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
